import styled from 'styled-components';

import { white } from 'styles/colors';

export const Description = styled.p`
    margin-top: 0;
    text-align: justify;
    color: ${white};
`;
